import { render, staticRenderFns } from "./Fountain.vue?vue&type=template&id=366b63dc&scoped=true&"
import script from "./Fountain.vue?vue&type=script&lang=js&"
export * from "./Fountain.vue?vue&type=script&lang=js&"
import style0 from "./Fountain.vue?vue&type=style&index=0&id=366b63dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b63dc",
  null
  
)

export default component.exports